module.exports = __webpack_public_path__ + "f9fec332da6c3b88da84bc93ca6aa1be.svg";